import SellerProfile from '../../../../../pages/vip/features/seller-reputation/seller-reputation';

export default SellerProfile;
